import { policyBySlug } from "./policies";

export const PUBLIC_ORIGIN = "https://policy-impact.wjstks3474.workers.dev";

export interface PageMetadata {
  title: string;
  description: string;
  canonicalPath: string;
  indexable: boolean;
}

export function pageMetadata(path: string): PageMetadata {
  const policyMatch = path.match(/^\/policy\/([^/]+)$/);
  const policy = policyMatch ? policyBySlug.get(decodeURIComponent(policyMatch[1])) : undefined;
  if (policy) return {
    title: `${policy.title} — 내 영향과 할 일 | 바뀜표`,
    description: `${policy.summary} 공식 원문, 정책 단계, 내 영향과 다음 행동을 한 화면에서 확인하세요.`,
    canonicalPath: `/policy/${policy.slug}`,
    indexable: true
  };
  const pages: Record<string, Pick<PageMetadata, "title" | "description">> = {
    "/": {title: "바뀜표 — 내 돈·자격·권리·마감의 정책 변화", description: "정책 이름을 몰라도 생활 상황을 고르면 공식 원문에 근거한 내 영향과 지금 할 일을 확인하고 저장할 수 있습니다."},
    "/ask": {title: "내 생활에 달라지는 정책 묻기 | 바뀜표", description: "생활 상황을 한 문장으로 적고 정책 단계, 돈·자격·권리의 변화와 다음 행동을 확인하세요."},
    "/updates": {title: "최근 정책 변화와 신청 마감 | 바뀜표", description: "공식 기관의 새 발표와 검수된 시행 변화, 신청·의견·갱신 마감을 구분해 확인하세요."},
    "/topics": {title: "생활 주제별 정책 질문 | 바뀜표", description: "일·소득, 연금·돌봄, 건강, 주거 등 생활 주제에서 정책 이름 없이 필요한 공식 확인 경로를 찾으세요."},
    "/explore": {title: "내 생활과 가까운 정책 찾기 | 바뀜표", description: "공식 원문을 확인한 정책을 생활 주제와 영향 기준으로 찾고 내 조건에 맞춰 계산하세요."},
    "/sources": {title: "공식 출처와 최신 확인 상태 | 바뀜표", description: "바뀜표가 6시간마다 확인하는 공식 기관과 개인 영향 검수 기준일을 확인하세요."},
    "/method": {title: "정책 영향 계산 원칙 | 바뀜표", description: "정책 단계와 공식 상수, 계산식, 불확실성을 어떻게 나누는지 확인하세요."},
    "/privacy": {title: "개인정보 처리 안내 | 바뀜표", description: "바뀜표가 질문과 프로필을 어디에 저장하고 무엇을 서버로 보내지 않는지 확인하세요."},
    "/terms": {title: "이용약관 | 바뀜표", description: "바뀜표의 정보 범위, 이용 조건, 공식 기관 최종 확인 원칙을 확인하세요."},
    "/pricing": {title: "요금 안내 | 바뀜표", description: "현재 제공 범위와 무료 이용 원칙, 향후 유료 기능의 사전 고지 원칙을 확인하세요."}
  };
  if (pages[path]) return {...pages[path], canonicalPath: path, indexable: true};
  const privatePaths = new Set(["/profile", "/watchlist", "/support"]);
  const privateRoute = privatePaths.has(path) || /^\/policy\/[^/]+\/share$/.test(path);
  return {
    title: "바뀜표 — 내 생활의 정책 변화",
    description: "공식 원문과 내 조건을 대조해 정책의 실제 영향과 다음 행동을 확인하세요.",
    canonicalPath: privateRoute ? path : "/",
    indexable: false
  };
}
